import './abandon-order.scss'
import { getLocalStorage, removeLocalStorage, setLocalStorage } from '@omnia/ui/src/lib'
import { OrderType } from '@vista-digital/ocapi-types/v1'
import { cancelOrder, getOrder, hasOrderBeenCreated, hasOrderExpired } from '@vista-digital/occ-domain'
import { Button, Modal } from '@vista-digital/occ-ui'
import { ButtonColor } from '@vista-digital/occ-ui/src/lib/subcomponents/button/types/color'
import { observer } from 'mobx-react'
import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom-v7'
import type { TicketingSubPages } from '@/common/services/models/pages'
import { navigationService } from '@/common/services/navigation.service'
import { ticketingWorkflow } from '@/pages/ticketing/ticketing-workflow'

const key = 'parked-order-id'
export const AbandonOrderModal = observer(() => {
    const [showModal, setShowModal] = useState(false)
    const location = useLocation()
    const currentPage = useMemo(() => navigationService.getCurrentPage(), [location.pathname])

    useEffect(() => {
        // Clear ticketing workflow state if the current page is not in the workflow and no order has been created
        if (!hasOrderBeenCreated()) {
            const ticketingSubpage = navigationService.getCurrentSubPage('Ticketing', location)?.alias
            if (!ticketingSubpage || !ticketingWorkflow.inWorkflow(ticketingSubpage as keyof TicketingSubPages)) {
                if (ticketingWorkflow.State.currentPage !== 'SeatPicker') {
                    ticketingWorkflow.end()
                }
            }
        }
    }, [location])

    useEffect(() => {
        const orderInProgress = hasOrderBeenCreated() && !hasOrderExpired()
        if (!orderInProgress) return

        const order = getOrder()
        if (order?.type !== OrderType.Standard) return

        const parkedOrderId = getLocalStorage<string>(key)
        setShowModal(parkedOrderId !== order?.id && !(currentPage === 'Ticketing'))
    }, [currentPage])

    const parkOrder = () => {
        setShowModal(false)
        const order = getOrder()
        order && setLocalStorage(key, order?.id)
    }

    const abandonOrder = () => {
        cancelOrder()
        ticketingWorkflow.end()
        removeLocalStorage(key)
        setShowModal(false)
    }

    return (
        <Modal className="abandon-order" show={showModal} canBeClosed={false} heading="booking in progress">
            <p className="modal-description">
                You already have a booking in progress. Do you want to abandon your booking or continue browsing?
            </p>
            <Button onClick={abandonOrder} color={ButtonColor.Primary}>
                Abandon Your Booking
            </Button>

            <Button className="btn-black" onClick={parkOrder}>
                Continue Browsing
            </Button>
        </Modal>
    )
})
